import PropType from "prop-types";
import { connect } from "react-redux";

const ExerciseTitle = ({
  exerciseName,
  instruction,
  activeCircuit,
}) => {
  return (
    <div className="mb-3 d-flex justify-content-between exercise-header-details">
      <h5>{exerciseName}</h5>
      <p className="instructions-text">{instruction}</p>
      <div className="set-container">
        <span className="set-label">Circuit</span>
        {[...Array(3)].map((_, index) => (
          <span
            key={index}
            className={`set-number ${
              index + 1 === activeCircuit ? "active" : ""
            }`}
          >
            {index + 1}
          </span>
        ))}
      </div>
    </div>
  );
};

ExerciseTitle.propTypes = {
  exerciseName: PropType.string.isRequired,
  instruction: PropType.string.isRequired,
};

const mapStatetoProps = (state) => ({
  activeCircuit: state.userActiveDayReducer.activeDay?.circuit,
});

export default connect(mapStatetoProps)(ExerciseTitle);
